import { z } from "zod";

export * from "./absence";
export * from "./acknowledgement-definition";
export * from "./address";
export * from "./alert";
export * from "./attendances";
export * from "./audit";
export * from "./auth";
export * from "./calculation";
export * from "./contact";
export * from "./cost-centers";
export * from "./dashboard";
export * from "./crew-definition";
export * from "./documents";
export * from "./emails";
export * from "./files";
export * from "./incoming-invoices";
export * from "./insights";
export * from "./integration";
export * from "./mailboxes";
export * from "./measurement";
export * from "./misc";
export * from "./notes";
export * from "./notifications";
export * from "./organization";
export * from "./partnership";
export * from "./plan";
export * from "./preferences";
export * from "./project";
export * from "./protocol";
export * from "./resource-link";
export * from "./role";
export * from "./services";
export * from "./settings";
export * from "./size";
export * from "./statistics";
export * from "./stock";
export * from "./table-type";
export * from "./task";
export * from "./terminal";
export * from "./ticket";
export * from "./ui";
export * from "./user";
export * from "./utils";
export * from "./vehicle";
export * from "./video-recorder";
export * from "./videos";
export * from "./weight";
export * from "./wiki";

export const sampleFormSchema = z.object({
	name: z.string(),
	num: z.number(),
});

export type SampleFormSchema = z.infer<typeof sampleFormSchema>;
